
import React, { useState } from "react";
import { Autocomplete, Box, Button, Grid, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import { DateFormScreen, NumberFormatCustom } from "../../components";
import { iconos } from "../../../data";
import { BotonesAndCargando } from "../../components/botones";
import { separadorMillares } from "../../../hooks";
import { useInventarioXProvedor, useProveedoresSelect } from "../../../hooks/cache";
import { crearGastoFactura } from "../../../services";

import Swal from "sweetalert2";
import { useQueryClient } from "@tanstack/react-query";
const initial = { factura: '', tipo: '', fecha: '', proveedor: '' }



export const FormularioCrearGasto = ({ handleCerrarModal }) => {


    const queryClient = useQueryClient();
    const millares = NumberFormatCustom;
    const { data:proveedoresList } = useProveedoresSelect();

    const [informacion, setInformacion] = useState(initial);
    const { factura, tipo, proveedor, fecha, cuantosDias } = informacion;
    const { data:inventario=[], isLoading } = useInventarioXProvedor(proveedor);
    const [items, setItems] = useState([{producto:null,  item:'', cantidad:'', precioUnidad:'', total:0}]);
    const [cargando, setCargando] = useState(false);
    

    const handleChangesInformacion = ({ target }) => {
        setInformacion( (resultado) => ({
            ...resultado,
            [target.name]: target.value
        }));
    }


    const handleChangeStart = (newValue) => {
        setInformacion( (resultado) => ({ ...resultado, fecha:newValue.toDate() }));
    };
    

    const actualizarItem = (index, campo, valor) => {
        const nuevos = [...items];
        nuevos[index][campo] = valor;
        if (campo === 'cantidad' || campo === 'precioUnidad') {
            nuevos[index].total = nuevos[index].cantidad * nuevos[index].precioUnidad;
        }
        setItems(nuevos);
    };


    const agregarItem = () => {
        setItems([ { producto:null, item:'', cantidad:'', precioUnidad:'', total:0 }, ...items ]);
    };


    const eliminarItem = (index) => {
        const nuevos = [...items];
        nuevos.splice(index, 1);
        setItems(nuevos);
    };



    const handleCrearGasto = async(e) => {
        e.preventDefault();
        if([factura, fecha, tipo].includes('')){
            return Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
        }

        if(items?.length < 1) return Swal.fire('Error', 'Debes añadir al menos un item', 'error');

        const { isConfirmed } = await Swal.fire({
            title: 'Crear Gasto',
            text: `¿Esta seguro de crear este gasto?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });

        if( !isConfirmed ) return;

        setCargando(true);
        const resp = await crearGastoFactura({ ...informacion, items });
        setCargando(false);
        if(resp){
            handleCerrarModal();
            queryClient.invalidateQueries({ queryKey: ['todos-gastos'] });
        }
    }



    return (
        <form autoComplete='off' style={{width:'100%'}} onSubmit={ handleCrearGasto }>
            <Grid container spacing={2} mb={2}>
                <Grid item xs={12}>
                    <TextField required
                        fullWidth
                        label='Factura'
                        placeholder='Factura'
                        name="factura"
                        value={factura}
                        onChange={ handleChangesInformacion }
                        size='small'
                    />
                </Grid>

                <Grid item xs={12}>
                    <DateFormScreen
                        label="Fecha de Gasto"
                        value={fecha}
                        onChange={handleChangeStart}
                        permitirPasado={true}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField 
                        required
                        select
                        fullWidth
                        label='Tipo de Gasto'
                        placeholder='Tipo de Gasto'
                        name="tipo"
                        value={tipo}
                        onChange={ handleChangesInformacion }
                        size='small'
                    >   
                        <MenuItem value=''> Seleccione Tipo Gasto</MenuItem>
                        <MenuItem value="COMPRA">COMPRA</MenuItem>
                        <MenuItem value="OPERATIVO">OPERATIVO</MenuItem>
                    </TextField>
                </Grid>

                {(tipo === 'COMPRA') && 
                <Grid item xs={12}>
                    <TextField
                        select
                        label="Proveedor"
                        fullWidth
                        name="proveedor"
                        value={proveedor}
                        onChange={ handleChangesInformacion } 
                        size="small" 
                    >    
                        <MenuItem value=''>Seleccione Proveedor</MenuItem>
                        {proveedoresList?.map( (m) => (
                            <MenuItem value={m.id} key={m.id}>{ m.nombre }</MenuItem>
                        ))}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12}>
                    <Typography sx={{fontSize:21, fontWeight:'bold', mt:2, mb:1}}>
                        Ítems de Gasto
                    </Typography>

                    <Box sx={{ width: '100%' }}>
                    {items.map((item, index) => (
                        <Box key={index} sx={{ mb:2, p:1, borderRadius:1, border:'2px solid', borderColor:'primary.main' }}>
                            <Grid container spacing={2} sx={{display:'flex', alignItems:'center'}}>
                                <Grid item xs={12}>
                                    {(tipo === 'COMPRA' && proveedor) &&
                                    <Autocomplete
                                        options={isLoading ? [] : inventario || []}
                                        getOptionLabel={(option) => option.nombre || ''}
                                        isOptionEqualToValue={(option, value) => option._id === value._id}
                                        // value={(inventario).find(p => p._id === item._id) || null}
                                        value={inventario?.find(p => p._id === item.producto) || null}
                                        onChange={(_, newValue) => {
                                            actualizarItem(index, 'producto', newValue?._id || null);
                                            actualizarItem(index, 'item', newValue?.nombre || '');
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Producto" size="small" fullWidth />
                                        )}
                                    />
                                    }

                                    {(tipo !== 'COMPRA') &&
                                    <TextField
                                        fullWidth
                                        label="Concepto"
                                        size="small"
                                        value={item.item}
                                        onChange={(e) => actualizarItem(index, 'item', e.target.value)}
                                    />
                                    }
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        label="Cantidad"
                                        type="number"
                                        size="small"
                                        value={item.cantidad}
                                        onChange={(e) => actualizarItem(index, 'cantidad', Number(e.target.value))}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <TextField 
                                        variant="outlined"
                                        label='Precio unitario'
                                        placeholder='Precio unitario'
                                        fullWidth
                                        name="precio"
                                        value={item.precioUnidad}
                                        onChange={(e) => actualizarItem(index, 'precioUnidad', Number(e.target.value))}
                                        InputProps={{ inputComponent: millares }}
                                        size="small"
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        label="Total"
                                        size="small"
                                        value={`$${separadorMillares(item.total)}`}
                                        disabled
                                    />
                                </Grid>

                                <Grid item xs={1}>
                                    <IconButton color="error" onClick={() => eliminarItem(index)} size="small">
                                        {React.cloneElement(iconos['eliminar'], { fontSize: 'small' })}
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Box>
                    ))}

                        <Button variant="contained" color="secondary" size="small" sx={{ mt:1 }} onClick={agregarItem}>
                            Agregar ítem
                        </Button>
                    </Box>
                </Grid>
            </Grid>


            <Grid container sx={{mb:1, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={'Crear Gasto'}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>

            {/* <AgregarItemsGastos data={data} setData={setData} /> */}
        </form>
    )

}
